/**
 * Hashtag per report info
 */
export class HashtagPerReport {
  /**
   * Key
   */
  key: string;

  /**
   * Property inside DTO
   */
  property: string;

  /**
   * DTP name
   */
  dto: string

  /**
   * Reflist name
   */
  reflist_name: string;

  /**
   * Hashtag value
   */
  value: string;

  /**
   * Page number
   */
  page: number;

  /**
   * Widget ID
   */
  widgetId: number;
}
